import { Injectable } from '@angular/core';
import { CrudService } from '../shared/grid/crud.service';
import { TaskOrgLevel } from '../models/taskOrgLevel.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaskOrgLevelService extends CrudService<TaskOrgLevel> {

  constructor(http: HttpClient) {
    super('TaskGroupOrgLevel', http)
  }

  getByTaskGroupId(taskGroupId: string, orgLevelId: string): Observable<TaskOrgLevel> {
    const params = new HttpParams()
      .set('taskGroupId', taskGroupId.toString())
      .set('parentOrgLevelId', orgLevelId.toString());

    return this.http.get<TaskOrgLevel[]>(
      this.getApiUrl(`${this.controllerName}/GetAssociations`), { params }
    ).pipe(
      map((items) => items.find(item => item.organizationLevelId === orgLevelId) ?? { taskGroupId, organizationLevelId: orgLevelId } as TaskOrgLevel)
    );
  }

  deleteById(taskGroupId: string, orgLevelId: string): Observable<TaskOrgLevel> {
    const params = new HttpParams()
      .set('taskGroupId', taskGroupId.toString())
      .set('organizationLevelId', orgLevelId.toString());

    return this.http.delete<TaskOrgLevel>(
      this.getApiUrl(`${this.controllerName}/Delete`), { params }
    );
  }
}
